import tracker from '../tracker/publish'

var app = require('app')
var $ = require('jquery')
var _ = require('underscore')

var AjaxForm = require('./views/ajax-form-extension')
var EditHelper = require('../../libs/helpers/edit').prototype

module.exports = app.Marionette.ItemView.extend({
  options: {
    showLeavingModal: true
  },

  template: false,

  ui: {
    attachments_container: '.js-attachments',
    form_content: '.js-wysiwyg-form-content',
    notifications: '.js-notification',
    notifications_upload: '.js-notifications--uploads',
    poll: '.add-poll',
    place_attachment: '.add-attachment__place-link',
    progressive_loader: '.progressive-editor',
    uploader_placeholder: '.js-image-uploader'
  },

  events: {
    'click @ui.place_attachment': 'placeAttachment'
  },

  containerIdentity: '#wysiwyg-textarea-',

  components: {
    attachments: function () {
      if (this.ui.attachments_container.length) {
        return {
          name: 'attachments',
          el: '@ui.attachments_container',
          data: {
            labels: this.options.phrases.attachments,
            attachments: this.options.attachments.items || [],
            imageAttachmentCdn: this.options.attachments.imageAttachmentCdn,
            input_name: this.options.attachments.input_name
          }
        }
      }
      return false
    },
    upload_notifications: function () {
      if (this.ui.notifications_upload.length) {
        var notificationId = _.uniqueId('notification_')
        this.notification_upload_id = notificationId
        return {
          name: 'notifications',
          el: '@ui.notifications_upload',
          data: {
            id: notificationId
          }
        }
      }
      return false
    },
    uploader: function () {
      if (this.ui.uploader_placeholder.length) {
        return {
          name: 'uploader',
          el: '@ui.uploader_placeholder',
          data: {
            allow_all_file_attachments: this.options.allow_all_file_attachments,
            allowed_files_type: this.options.allowed_file_types,
            allowed_files_size: this.options.allowed_file_sizes,
            labels: this.options.phrases.uploader.labels
          }
        }
      }
      return false
    },
    notifications: function () {
      var notificationId = app._.uniqueId('notification_')
      this.notificationId = notificationId
      return {
        name: 'notifications',
        el: '@ui.notifications',
        data: {
          id: notificationId
        }
      }
    }
  },

  editor: null,

  isGuest: false,

  uploader: false,

  uploads: [],

  uploadingFile: false,

  onShowErrorsUpload: function (errors) {
    this.ui.notifications_upload.show()
    this.onShowErrors(errors, this.notification_upload_id)
    this.components.upload_notifications.render()
  },

  onShowErrors: function (errors, notificationId) {
    this.ui.notifications.show()
    if (!notificationId) {
      notificationId = this.notificationId
        ? this.notificationId + ':'
        : ''
    } else {
      notificationId = notificationId + ':'
    }

    var notification = 'notification:' + notificationId + 'show'

    if (errors.length > 1) {
      var _errors = app._.map(errors, function (error) {
        return { type: 'error', msg: error }
      })
      app.events.commands.execute(notification, _errors)
    } else {
      app.events.commands.execute(notification, [
        { type: 'error', msg: errors[0] }
      ])
    }
    this.components.notifications.render()
  },

  onComponentUploaderLoaded: function (instance) {
    var self = this
    var formId = $(this.$el).find('form').attr('id')
    this.uploader = instance
    instance.on('image:upload:start file:upload:start', function () {
      var id = _.uniqueId('upload_')
      self.uploads.push(id)
      app.events.commands.execute('attachment:' + formId + ':add', {
        id: id
      })
    })

    instance.on('image:upload:end', function (json) {
      var id = self.uploads.shift()
      app.events.commands.execute('attachment:' + formId + ':set', id, json)
    })

    instance.on('file:upload:start', function (json) {
      self.uploadingFile = true
    })

    instance.on('file:upload:end', function (json) {
      var id = self.uploads.shift()
      app.events.commands.execute('attachment:' + formId + ':set', id, json)
      self.uploadingFile = false
    })

    instance.on('upload:error', function (errors) {
      var id = self.uploads.shift()
      app.events.commands.execute('attachment:' + formId + ':remove', id)
      self.triggerMethod('show:errors:upload', errors)
    })
  },

  onUpload: function (type) {
    app.events.commands.execute(
      'notification:' + this.notificationUploadId + ':clean'
    )
    var attachmentsFilesSize = type === 'file' ? this.components.attachments.attachmentsFileSize() : -1
    var attachmentsSizeLimit = type === 'file' ? this.options.attachments.post_files_size_limit : -1
    this.uploader.triggerMethod('upload:choose', {
      type: type,
      files_size: attachmentsFilesSize,
      limit: attachmentsSizeLimit
    })
  },

  placeAttachment: function (e) {
    e.preventDefault()
    var $el = $(e.currentTarget)
    var prop = $el.data('bbcode') || ''
    var value = $el.data('rel') || ''

    if (prop === 'img') {
      this.editor.insertImage(this.options.imageAttachmentCdn + value)
    }
    return false
  },

  quote: function (e) {
    e.preventDefault()
    var $el = $(e.currentTarget)
    var userName = $el.data('rel')
    var meta = $el.data('meta')

    var editingInstance = $.data(document.body, 'editingEditor')
    var mainInstance = $.data(document.body, 'mainEditor')
    var instance = editingInstance !== undefined ? editingInstance : mainInstance
    var self = this
    var quoteContent = instance.editor.transformDialectToHtml(
      self.getBBCodeText('quote', userName, meta)
    )

    instance.editor.insertHtml(quoteContent)

    instance.editor.focus()

    return false
  },

  addToTextarea: function (content) {
    // @TODO: append text in editor
    this.editor.appendText(content)
  },

  getBBCodeText: function (prop, value, meta) {
    if (prop && value === false && meta === false) {
      return '[' + prop + '=]'
    } else if (prop && value !== false && meta === false) {
      return '[' + prop + ']' + value + '[/' + prop + ']'
    } else if (prop && value && meta) {
      return '[' + prop + '=' + value + ']' + meta + '[/' + prop + ']'
    }
  },

  injectWysiwyg: function () {
    var self = this
    if (self.editor === null) {
      require.ensure([], function (require) {
        var WysiwygEditor = require('editor-wysiwyg')
        self.editor = new WysiwygEditor(self.editorOptions)
        self.start()

        if (self.isEditing()) {
          self.editor.focus()
        }
      }, 'wysiwyg-editor')
    }
  },

  hideProgressiveLoader: function () {
    this.ui.progressive_loader.fadeOut('fast')
  },

  hideNotifications: function () {
    this.ui.notifications.hide()
    this.ui.notifications_upload.hide()
  },

  bindEvents: function () {
    var self = this
    this.$form.on('toggle:loading', function () {
      self.editor.ui.toggleSubmit(true)
    })
    this.$form.on('show:errors', function () {
      self.ui.notifications.show()
      self.editor.ui.toggleSubmit(false)
    })
    this.editor.getInstance().on('editor-change', function () {
      self.hideNotifications()
    })
    this.ui.editor_container.on('editor:error', function (e, data) {
      self.onShowErrors(data.detail.errors, self.notificationId)
    })
    this.ui.editor_container.on('editor:attachment', function (e, data) {
      self.onUpload(data.type)
    })
    this.ui.editor_container.on('editor:help', function () {
      self.displayHelp()
    })
    this.ui.editor_container.on('editor:poll', function () {
      self.togglePoll()
    })
    this.ui.editor_container.on('editor:submit', function (e) {
      self.hideNotifications()
      if (!self.uploadingFile) {
        self.submitContent(e)
      }
    })
    this.ui.editor_container.on('editor:cancel', function () {
      self.hideNotifications()
      self.cancel()
    })
    this.bindUploaderEvents()
    app.events.commands.setHandler(
      'editor:bbcode:add',
      function (event) {
        var $el = $(event.currentTarget)
        var type = $el.data('helper')

        switch (type) {
          case 'quote':
            self.quote(event)
            break
        }
      }
    )
    if (self.$form.find('button[type=submit]').length) {
      self.$form.find('button[type=submit]').on('click', function (e) {
        e.stopPropagation()
        self.submitContent(e)
      })
    }
  },

  bindUploaderEvents: function () {
    const self = this
    if (this.components.uploader) {
      this.components.uploader.on('image:upload:start', function () {
        self.editor.disable()
      })
      this.components.uploader.on('image:upload:end', function (json) {
        self.editor.insertImage(json.source)
        self.editor.enable()
      })
      this.components.uploader.on('upload:error', function (errors) {
        self.editor.enable()
        self.triggerMethod('show:errors:upload', errors)
      })
    }
  },

  unbindEvents: function () {
    this.$form.off('toggle:loading')
    this.$form.off('show:errors')
    this.editor.getInstance().off('editor-change')
    this.ui.editor_container.off('editor:attachment')
    this.ui.editor_container.off('editor:submit')
    this.ui.editor_container.off('editor:cancel')
    this.components.uploader.off('image:upload:start')
    this.components.uploader.off('image:upload:end')
    this.components.uploader.off('file:upload:end')
    this.components.uploader.off('upload:error')
  },

  displayHelp: function () {
    app.events.commands.execute('modal:editor-bbcode-modal:show')
  },

  togglePoll: function () {
    this.ui.poll.toggleClass('is-hidden')
  },

  submitContent: function (e) {
    this.ui.form_content.val(this.editor.getDialectContent())
    this.ajaxForm.submitForm(e)
  },

  start: function () {
    this.hideProgressiveLoader()
    if (!this.options.isGuest) {
      this.bindEvents()
    }
    setTimeout(() => {
      if (this.options.profile === 'forum_create') {
        tracker.trackEvent('userevent', {
          'topic_has_title_prefilled': false,
          type: 'Create Topic Form Viewed'
        }, () => {})
      }
    })
  },

  initialize: function (options) {
    var self = this
    var editorId = this.$el.attr('id')

    self.isGuest = options.isGuest
    self.$form = this.$el.find('.js-wysiwyg-form')
    self.ui.editor_container = self.containerIdentity + editorId

    if (self.isGuest) {
      self.$el.on('click', function () {
        app.events.commands.execute('modal:login:show')
      })
    }

    self.manageEditing()
    self.initEditHelper()

    self.ajaxForm = new AjaxForm({
      el: self.$form[0],
      onSuccessRedirect: true
    })
    self.ajaxForm.render()

    self.editorOptions = {
      container: self.ui.editor_container,
      dialect: 'bbcode',
      isCancelable: self.options.isCancelable,
      profile: self.options.profile,
      features: self.options.features,
      topicId: self.options.topicId,
      phrases: self.options.phrases,
      disabled: self.options.isGuest,
      fileAttachments: self.options.allow_all_file_attachments,
      allowPoll: true,
      allowImageAndVideoUpload: self.options.allowImageAndVideoUpload
    }

    if (window.location.pathname === '/topic/new') {
      this.addUnloadListener()
    }

    if (self.$form.find('button[type=submit]').length) {
      self.$form.find('button[type=submit]').on('click', function (e) {
        self.options.showLeavingModal = false
      })
    }

    if (!$(self.ui.editor_container).length) return

    self.injectWysiwyg()
  },

  addUnloadListener: function () {
    var self = this

    // Show default browser modal when leaving page
    window.addEventListener('beforeunload', function (e) {
      if (self.hasUnsavedChanges()) {
        // Cancel the unload event as stated by the standard.
        e.preventDefault()
        // Chrome requires returnValue to be set.
        e.returnValue = ''
      }
    })
  },

  hasUnsavedChanges: function () {
    var topicTitle = document.querySelector('#topic_title')
    var quillEditor = document.querySelector('.ql-editor')
    var firstPostContent = document.querySelector('input[name="topic[firstPost][content]"]') &&
    document.querySelector('input[name="topic[firstPost][content]"]').value

    var isBlank = quillEditor
      ? quillEditor.classList.contains('ql-blank')
      : !firstPostContent

    return (topicTitle.value || !isBlank) && this.options.showLeavingModal
  },

  isEditing: function () {
    return this.options.mode === 'editing'
  },

  cancel: function () {
    this.destroy()
  },

  initEditHelper: function () {
    EditHelper.onRenderForm = function (data) {
      this.ui.content.hide()
      this.ui.edit_box.html(data)
      app.initDataElements(this.ui.edit_box)
      this.bindUIElements()
    }

    EditHelper.bindDestroy = function () {
    }
  },

  manageEditing: function () {
    if (!this.isEditing()) {
      $.data(document.body, 'mainEditor', this)
      return
    }

    var editorId = this.$el.attr('id')
    var editingInstance = $.data(document.body, 'editingEditor')

    if (editingInstance && editingInstance.$el.attr('id') !== editorId) {
      editingInstance.destroy()
    }

    $.data(document.body, 'editingEditor', this)
  },

  onDestroy: function () {
    var parent = this.$el.parent('.js-content--editable')
    parent.siblings('.js-content--original').show()

    EditHelper.onCancelEdit()
    this.unbindEvents()
    this.editor.destroy()
    this.editor = null
    delete this.editor
    this.$el.remove()
    parent.html('')

    var editingInstance = $.data(document.body, 'editingEditor')
    if (editingInstance && editingInstance.$el.attr('id') === this.$el.attr('id')) {
      $.removeData(document.body, 'editingEditor')
    }
  }
})
